import { Injectable } from '@angular/core';
import { PurchaseRow } from '../../../models/interfaces/god-orders.interface';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ModalAmbassadorPopupComponent } from '../../../components/modals/modal-ambassador-popup/modal-ambassador-popup.component';
import { ModalChangePasswordComponent } from '../../../components/modals/modal-change-password/modal-change-password.component';
import { ModalChangeRoleComponent } from '../../../components/modals/modal-change-role/modal-change-role.component';
import { ModalCourseDocumentBlockedComponent } from '../../../components/modals/modal-course-document-blocked/modal-course-document-blocked.component';
import { ModalDiplomaComponent } from '../../../components/modals/modal-diploma/modal-diploma.component';
import { ModalForgotPasswordComponent } from '../../../components/modals/modal-forgot-password/modal-forgot-password.component';
import { ModalPromotionPopupComponent } from '../../../components/modals/modal-promotion-popup/modal-promotion-popup.component';
import { ModalViewExamAnswersComponent } from '../../../components/modals/modal-view-exam-answers/modal-view-exam-answers.component';
import { AmbassadorPopupDto } from '../../../models/dto/ambassador-popup.dto';
import { ActivePromotionDto } from '../../../models/dto/promotion.dto';
import { Role } from '../../../models/enums/role.enum';
import { CourseModality } from '../../../models/enums/course-mode.enum';
import { Affiliate } from '../../../models/interfaces/affiliate.interface';
import { Ambassador, AmbassadorExample, AmbassadorVideo } from '../../../models/interfaces/ambassador.interface';
import { AnsweredExam } from '../../../models/interfaces/answered_exam.interface';
import { Country } from '../../../models/interfaces/country.interface';
import { Course } from '../../../models/interfaces/course.interface';
import { MembersCategory } from '../../../models/interfaces/members_category.interface';
import { MembersCourse } from '../../../models/interfaces/members_course.interface';
import { MembersLevel } from '../../../models/interfaces/members_level.interface';
import { Product } from '../../../models/interfaces/product.interface';
import { Student } from '../../../models/interfaces/student.interface';
import { ModalAddClassCommentComponent } from '../../../pages/common/course-class-content/components/modal-add-class-comment/modal-add-class-comment.component';
import { ModalAddTfmCommentComponent } from '../../../pages/god/tfm/god-tfm-drafts/modal-add-tfm-comment/modal-add-tfm-comment.component';
import {
  ClassRatingModalComponent,
  ClassRatingDialogData
} from '../../../pages/common/course-class-content/class-rating-modal/class-rating-modal.component';
import {
  AdminClassReviewsModalComponent,
  AdminReviewsModalData
} from '../../../pages/common/course-class-content/admin-class-reviews-modal/admin-class-reviews-modal.component';
import {
  QuizFlowComponent,
  QuizFlowDialogData,
  QuizFlowDialogResult
} from '../../../pages/common/course-class-content/quiz-flow/quiz-flow.component';
import { ModalAffiliateLinksComponent } from '../../../pages/god/affiliates/components/modal-affiliate-links/modal-affiliate-links.component';
import { ModalAffiliatePaymentComponent } from '../../../pages/god/affiliates/components/modal-affiliate-payment/modal-affiliate-payment.component';
import { ModalEditAffiliatePaymentComponent } from '../../../pages/god/affiliates/components/modal-affiliate-sales/components/modal-edit-affiliate-payment/modal-edit-affiliate-payment.component';
import { ModalAffiliateSalesComponent } from '../../../pages/god/affiliates/components/modal-affiliate-sales/modal-affiliate-sales.component';
import { ModalEditAffiliateComponent } from '../../../pages/god/affiliates/components/modal-edit-affiliate/modal-edit-affiliate.component';
import { ModalAmbassadorInfoComponent } from '../../../pages/god/ambassador-info/components/modal-ambassador-info/modal-ambassador-info.component';
import { ModalAmbassadorExampleComponent } from '../../../pages/god/ambassador-examples/components/modal-ambassador-example/modal-ambassador-example.component';
import { ModalEditAmbassadorPopupComponent } from '../../../pages/god/ambassador-popups/components/modal-edit-ambassador-popup/modal-edit-ambassador-popup.component';
import { ModalGodAddSalesComponent } from '../../../pages/god/ambassador-statistics/components/modal-god-add-sales/modal-god-add-sales.component';
import { ModalEditAmbassadorComponent } from '../../../pages/god/ambassadors/components/modal-edit-ambassador/modal-edit-ambassador.component';
import { EventsFormComponent } from '../../../pages/god/events/events-form/events-form.component';
import { ModalCloneExamComponent } from '../../../pages/god/exams/exams-list/components/modal-clone-exam/modal-clone-exam.component';
import { ModalViewExamAnswersAsAdminComponent } from '../../../pages/god/exams/exams-list/components/modal-view-exam-answers-as-admin/modal-view-exam-answers-as-admin.component';
import { ModalBulkEmailComponent } from '../../../pages/god/god-courses/components/god-course-list-card/components/modal-bulk-email/modal-bulk-email.component';
import { ModalCloneCourseComponent } from '../../../pages/god/god-courses/components/god-course-list-card/components/modal-clone-course/modal-clone-course.component';
import { ModalCourseStudentsComponent } from '../../../pages/god/god-courses/components/god-course-list-card/components/modal-course-students/modal-course-students.component';
import { ModalCourseStudentsMatriculationComponent } from '../../../pages/god/god-courses/components/god-course-list-card/components/modal-course-students-matriculation/modal-course-students-matriculation.component';
import { ModalFinalBulkEmailComponent } from '../../../pages/god/god-courses/components/god-course-list-card/components/modal-final-bulk-email/modal-final-bulk-email.component';
import { ModalStudentCourseAssignmentComponent } from '../../../pages/god/god-courses/components/god-course-list-card/components/modal-student-course-assignment/modal-student-course-assignment.component';
import { ModalEditCourseComponent } from '../../../pages/god/god-courses/components/modal-edit-course/modal-edit-course.component';
import { ModalEditMembersCategoryComponent } from '../../../pages/god/god-members/components/modal-edit-members-category/modal-edit-members-category.component';
import { ModalEditMembersClassComponent } from '../../../pages/god/god-members/components/modal-edit-members-class/modal-edit-members-class.component';
import { ModalEditMembersDataComponent } from '../../../pages/god/god-members/components/modal-edit-members-data/modal-edit-members-data.component';
import { ModalMessageFormComponent } from '../../../pages/god/messages/components/modal-message-form/modal-message-form.component';
import { ModalLinkPaymentComponent } from '../../../pages/god/orders/components/modal-link-payment/modal-link-payment.component';
import { ModalChangeOrderDateComponent } from '../../../pages/god/orders/components/modal-change-order-date/modal-change-order-date.component';
import { ModalEditProductComponent } from '../../../pages/god/products/components/modal-edit-product/modal-edit-product.component';
import { ModalNewProductComponent } from '../../../pages/god/products/components/modal-new-product/modal-new-product.component';
import { PromotionsFormComponent } from '../../../pages/god/promotions/promotions-form/promotions-form.component';
import { ModalAddStudentComponent, ModalAddStudentData } from '../../../pages/god/students/components/modal-add-student/modal-add-student.component';
import { ModalAssignCourseComponent } from '../../../pages/god/students/components/modal-assign-course/modal-assign-course.component';
import {
  ModalDiplomaDatesComponent,
  ModalDiplomaDatesData
} from '../../../pages/god/students/components/modal-diploma-dates/modal-diploma-dates.component';
import { ModalIssueDiplomaComponent } from '../../../pages/god/students/components/modal-issue-diploma/modal-issue-diploma.component';
import { ModalEditStudentDataComponent } from '../../../pages/god/students/components/modal-edit-student-data/modal-edit-student-data.component';
import { ModalStudentCoursesComponent } from '../../../pages/god/students/components/modal-student-courses/modal-student-courses.component';
import { ModalUnassignCourseComponent } from '../../../pages/god/students/components/modal-unassign-course/modal-unassign-course.component';
import { ModalAddAdminComponent } from '../../../pages/god/users/components/modal-add-user/modal-add-user.component';
import { ModalApprovalLinksComponent } from '../../../pages/public/cart/components/modal-approval-links/modal-approval-links.component';
import { ModalVerificationCodeComponent } from '../../../pages/public/cart/components/modal-verification-code';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private changePasswordModalOpen = false;
  private diplomaModalOpen = false;
  private courseDocumentBlockedModalOpen = false;

  get isChangePasswordModalOpen(): boolean {
    return this.changePasswordModalOpen;
  }

  constructor(
    private dialog: MatDialog,
    private toast: ToastService
  ) {}

  async openCourseDocumentBlockedModal(): Promise<void> {
    if (this.courseDocumentBlockedModalOpen) return;

    this.courseDocumentBlockedModalOpen = true;
    try {
      const dialogRef = this.dialog.open(ModalCourseDocumentBlockedComponent, {
        closeOnNavigation: false,
        disableClose: true,
        width: '600px',
        maxWidth: 'calc(100% - 32px)',
        height: 'fit-content',
        autoFocus: false
      });

      await firstValueFrom(dialogRef.afterClosed());
    } finally {
      this.courseDocumentBlockedModalOpen = false;
    }
  }

  async openAddClassCommentModal(courseClassId: string, parentCommentId?: string): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth = '600px';

    if (screenWidth < 768) {
      modalWidth = '100%';
    }

    try {
      const dialogRef = this.dialog.open(ModalAddClassCommentComponent, {
        closeOnNavigation: false,
        disableClose: true,
        width: modalWidth,
        maxWidth: '100%',
        data: {
          courseClassId,
          parentCommentId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de comentarios');
    }
  }

  /** ENF-2314 — same modal as openAddClassCommentModal, keyed by courseYearId instead of
   * courseClassId; ModalAddClassCommentComponent branches on which one is present. */
  async openAddClassZeroCommentModal(courseYearId: string, parentCommentId?: string): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth = '600px';

    if (screenWidth < 768) {
      modalWidth = '100%';
    }

    try {
      const dialogRef = this.dialog.open(ModalAddClassCommentComponent, {
        closeOnNavigation: false,
        disableClose: true,
        width: modalWidth,
        maxWidth: '100%',
        data: {
          courseYearId,
          parentCommentId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de comentarios');
    }
  }

  async openAddTfmCommentModal(courseId: string, submissionId: number, parentId?: number | null, type: 'draft' | 'final' = 'draft'): Promise<any> {
    const screenWidth = window.innerWidth;
    const modalWidth = screenWidth < 768 ? '100%' : '600px';

    try {
      const dialogRef = this.dialog.open(ModalAddTfmCommentComponent, {
        closeOnNavigation: false,
        disableClose: true,
        width: modalWidth,
        maxWidth: '100%',
        data: { courseId, submissionId, parentId: parentId ?? null, type }
      });
      return (await firstValueFrom(dialogRef.afterClosed())) || false;
    } catch {
      this.toast.presentErrorToast('Hubo un error con la ventana de comentarios');
    }
  }

  async openGodAddSalesModal(): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth = '980px';

    if (screenWidth < 768) {
      modalWidth = '95%';
    }

    try {
      const dialogRef = this.dialog.open(ModalGodAddSalesComponent, {
        closeOnNavigation: true,
        disableClose: false,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: false,
        data: {}
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de añadir ventas manualmente');
    }
  }

  async openStudentCoursesModal(courses: Array<Course>, studentId: string, fullname: string): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '60%';
    } else if (screenWidth >= 1600) {
      modalWidth = '50%';
    }

    try {
      const dialogRef = this.dialog.open(ModalStudentCoursesComponent, {
        closeOnNavigation: true,
        disableClose: false,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: false,
        data: {
          courses,
          studentId,
          fullname
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de cursos');
    }
  }

  async openAddStudentModal(data: ModalAddStudentData = {}): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '35%';
    }

    try {
      const dialogRef = this.dialog.open(ModalAddStudentComponent, {
        closeOnNavigation: true,
        disableClose: false,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        // EnfafModal adds a top margin of at least 155px inside the pane; at 80vh that clipped the
        // action buttons on a 1080p screen once the DNI field was added.
        maxHeight: '95vh',
        height: 'fit-content',
        autoFocus: true,
        data
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de agregar estudiante');
    }
  }

  async openAssignCourseModal(studentId: string, fullname: string, availableCourses: Array<Course>, obtainedCourses: Array<Course>): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '35%';
    }

    try {
      const dialogRef = this.dialog.open(ModalAssignCourseComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: false,
        data: {
          studentId,
          fullname,
          availableCourses,
          obtainedCourses
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de asignar cursos');
    }
  }

  async openUnassignCourseModal(studentId: string, fullname: string, obtainedCourses: Array<Course>): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '35%';
    }

    try {
      const dialogRef = this.dialog.open(ModalUnassignCourseComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: false,
        data: {
          studentId,
          fullname,
          obtainedCourses
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de quitar acceso a cursos');
    }
  }

  /**
   * @param options.presetPredecessorCourseId root course to preselect as predecessor when creating
   *   a new edition from the course list (ENF-2386 · B.6). Only meaningful without `courseId`.
   */
  async openEditCourseModal(courseId?: string, options?: { presetPredecessorCourseId?: string }): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalEditCourseComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        data: {
          courseId,
          presetPredecessorCourseId: options?.presetPredecessorCourseId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar curso');
    }
  }

  async openCourseStudentsModal(course: Course): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalCourseStudentsComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: ['modal-tabs', 'modal-full'],
        width: '100vw',
        maxWidth: '100vw',
        height: '100vh',
        maxHeight: '100vh',
        autoFocus: false,
        data: course
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de estudiantes del curso');
    }
  }

  async openCourseStudentsMatriculationModal(course: Course): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalCourseStudentsMatriculationComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: ['modal-tabs', 'modal-full', 'modal-course-students-matriculation'],
        width: '1200px',
        maxWidth: 'calc(100vw - 32px)',
        height: '90vh',
        maxHeight: '90vh',
        autoFocus: false,
        data: course
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch {
      this.toast.presentErrorToast('Hubo un error con la ventana de estudiantes del curso');
    }
  }

  /**
   * Clone a course. `modality` and `masterName` tell the dialog whether the source is a Máster (root or edition): its
   * clone is a new, independent Máster named after the typed master name (ENF-2372, E-9).
   */
  async openCloneCourseModal(
    courseId: string,
    courseName: string,
    source: { modality?: CourseModality | null; masterName?: string | null } = {}
  ): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '95%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '60%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '50%';
    }

    try {
      const dialogRef = this.dialog.open(ModalCloneCourseComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        height: 'fit-content',
        maxHeight: '80vh',
        autoFocus: true,
        data: {
          courseId,
          courseName,
          modality: source.modality ?? null,
          masterName: source.masterName ?? null
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de clonar curso');
    }
  }

  async openEditProductModal(availableCourses: Array<Course>, product?: Product): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalEditProductComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        maxWidth: '980px',
        autoFocus: false,
        data: {
          availableCourses,
          product
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar producto');
    }
  }

  async openNewProductModal(availableCourses: Array<Course>): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalNewProductComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        maxWidth: '980px',
        autoFocus: false,
        data: {
          availableCourses
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      console.error('❌ Error en openNewProductModal:', _error);
      this.toast.presentErrorToast('Hubo un error con la ventana de nuevo producto');
    }
  }

  async openApprovalLinksModal(links: any): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '95%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '60%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '60%';
    } else if (screenWidth >= 1600) {
      modalWidth = '50%';
    }

    try {
      const dialogRef = this.dialog.open(ModalApprovalLinksComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        height: 'fit-content',
        maxHeight: '80vh',
        autoFocus: false,
        data: {
          links
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de links de aprobación');
    }
  }

  async openForgotPasswordModal(email?: string): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '35%';
    }

    try {
      const dialogRef = this.dialog.open(ModalForgotPasswordComponent, {
        closeOnNavigation: true,
        disableClose: false,
        panelClass: 'modal-general-forgot-password',
        width: modalWidth,
        maxWidth: '600px',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: false,
        data: {
          email
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de olvidar contraseña');
    }
  }

  async openViewExamAnswersModal(
    examName: string,
    answeredExams: Array<AnsweredExam>,
    totalQuestions: number,
    requiredQuestions: number,
    studentName?: string
  ): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalViewExamAnswersComponent, {
        closeOnNavigation: true,
        disableClose: false,
        panelClass: 'modal-general',
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        autoFocus: false,
        data: {
          examName,
          answeredExams,
          studentName,
          totalQuestions,
          requiredQuestions
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de ver respuestas');
    }
  }

  async openViewExamAnswersAsAdminModal(examId: string, examName: string, totalQuestions: number, requiredQuestions: number): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalViewExamAnswersAsAdminComponent, {
        closeOnNavigation: true,
        disableClose: false,
        panelClass: 'modal-list',
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        autoFocus: false,
        data: {
          examId,
          examName,
          totalQuestions,
          requiredQuestions
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de ver calificaciones');
    }
  }

  async openEditAffiliateModal(affiliate?: Affiliate): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '70%';
    } else if (screenWidth >= 1600) {
      modalWidth = '40%';
    }

    try {
      const dialogRef = this.dialog.open(ModalEditAffiliateComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: true,
        data: { affiliate }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar afiliado');
    }
  }

  async openAffiliateLinksModal(fullname: string, links: Array<{ product: string; url: string }>): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '35%';
    }

    try {
      const dialogRef = this.dialog.open(ModalAffiliateLinksComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: false,
        data: { fullname, links }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de links de afiliado');
    }
  }

  async openAffiliateSalesModal(affiliateId: string, fullname: string): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalAffiliateSalesComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: ['modal-full', 'modal-tabs'],
        width: '100vw',
        maxWidth: '100vw',
        height: '100vh',
        maxHeight: '100vh',
        autoFocus: false,
        data: { affiliateId, fullname }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de ventas del afiliado');
    }
  }

  async openChangePasswordModal(): Promise<any> {
    if (this.changePasswordModalOpen) return;
    this.changePasswordModalOpen = true;

    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '70%';
    } else if (screenWidth >= 1600) {
      modalWidth = '60%';
    }

    try {
      const dialogRef = this.dialog.open(ModalChangePasswordComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '600px',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: true,
        data: {}
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      this.changePasswordModalOpen = false;
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de cambiar contraseña');
    }
  }

  async openAffiliatePaymentModal(affiliatePaymentId: string, totalToPay: number, totalPaid: number): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '35%';
    }

    try {
      const dialogRef = this.dialog.open(ModalAffiliatePaymentComponent, {
        closeOnNavigation: true,
        disableClose: false,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: false,
        data: {
          affiliatePaymentId,
          totalToPay,
          totalPaid
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de modificar pago del afiliado');
    }
  }

  async openEditAffiliatePaymentModal(affiliateUserId: string, payment?: any): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '35%';
    }

    try {
      const dialogRef = this.dialog.open(ModalEditAffiliatePaymentComponent, {
        closeOnNavigation: true,
        disableClose: false,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: false,
        data: {
          affiliateUserId,
          payment
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar pago del afiliado');
    }
  }

  async openCloneExamModal(courses: Array<Course>, examId: string, examName: string, courseId: string, sectionId: string | null): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '95%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '60%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '50%';
    }

    try {
      const dialogRef = this.dialog.open(ModalCloneExamComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        height: 'fit-content',
        maxHeight: '80vh',
        autoFocus: true,
        data: {
          courses,
          examId,
          examName,
          courseId,
          sectionId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de clonar examen');
    }
  }

  async openEditMembersDataModal(course: MembersCourse): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '95%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '60%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '50%';
    }
    try {
      const dialogRef = this.dialog.open(ModalEditMembersDataComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        height: 'fit-content',
        maxHeight: '80vh',
        autoFocus: true,
        data: {
          course
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar datos de members');
    }
  }

  async openEditMembersCategoryModal(currentCategories: Array<MembersCategory>, membersCategoryId?: string): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '95%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '60%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '50%';
    } else if (screenWidth >= 1600) {
      modalWidth = '50%';
    }
    try {
      const dialogRef = this.dialog.open(ModalEditMembersCategoryComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        height: 'fit-content',
        maxHeight: '80vh',
        autoFocus: true,
        data: {
          currentCategories,
          membersCategoryId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar categoría de members');
    }
  }

  async openEditMembersClassModal(categories: Array<MembersCategory>, levels: Array<MembersLevel>, membersClassId?: string): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '95%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '60%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '60%';
    } else if (screenWidth >= 1600) {
      modalWidth = '60%';
    }
    try {
      const dialogRef = this.dialog.open(ModalEditMembersClassComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        height: 'fit-content',
        maxHeight: '80vh',
        autoFocus: true,
        data: {
          categories,
          levels,
          membersClassId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar clase de members');
    }
  }

  async openDiplomaModal(freeCourseCompleted: boolean, courseName: string, sendDiploma = false): Promise<any> {
    if (this.diplomaModalOpen) return;
    this.diplomaModalOpen = true;

    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '70%';
    } else if (screenWidth >= 1600) {
      modalWidth = '40%';
    }

    try {
      const dialogRef = this.dialog.open(ModalDiplomaComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        height: 'fit-content',
        maxHeight: '80vh',
        autoFocus: false,
        data: { freeCourseCompleted, courseName, sendDiploma }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      this.diplomaModalOpen = false;
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de diploma');
    }
  }

  async openDiplomaDatesModal(
    courseId: string,
    userId: string,
    courseName: string,
    existingStartDate?: string | null,
    existingEndDate?: string | null
  ): Promise<any> {
    const screenWidth = window.innerWidth;
    const modalWidth = screenWidth < 768 ? '95%' : screenWidth < 1200 ? '70%' : '45%';

    try {
      const data: ModalDiplomaDatesData = { courseId, userId, courseName, existingStartDate, existingEndDate };
      const dialogRef = this.dialog.open(ModalDiplomaDatesComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: ['modal-general', 'modal-diploma-dates-panel'],
        width: modalWidth,
        maxWidth: '100%',
        height: 'fit-content',
        maxHeight: '80vh',
        autoFocus: false,
        data
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de fechas del diploma');
    }
  }

  async openIssueDiplomaModal(courseId: string, userId: string, courseName: string): Promise<any> {
    const screenWidth = window.innerWidth;
    const modalWidth = screenWidth < 768 ? '95%' : '600px';

    try {
      const dialogRef = this.dialog.open(ModalIssueDiplomaComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: ['modal-general'],
        width: modalWidth,
        maxWidth: '600px',
        data: { courseId, userId, courseName }
      });

      return await firstValueFrom(dialogRef.afterClosed());
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de expedir y enviar diploma');
    }
  }

  async openBulkEmailModal(courseId: string, courseName: string): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalBulkEmailComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        width: '980px',
        data: {
          courseId,
          courseName
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de enviar correo masivo');
    }
  }

  async openEditStudentDataModal(student: Student, countries: Array<Country>): Promise<any> {
    const screenWidth = window.innerWidth;
    let modalWidth;
    if (screenWidth < 768) {
      modalWidth = '95%';
    } else if (screenWidth >= 768 && screenWidth < 992) {
      modalWidth = '80%';
    } else if (screenWidth >= 992 && screenWidth < 1200) {
      modalWidth = '70%';
    } else if (screenWidth >= 1200 && screenWidth < 1600) {
      modalWidth = '60%';
    } else if (screenWidth >= 1600) {
      modalWidth = '50%';
    }

    try {
      const dialogRef = this.dialog.open(ModalEditStudentDataComponent, {
        closeOnNavigation: true,
        disableClose: false,
        panelClass: 'modal-general',
        width: modalWidth,
        maxWidth: '100%',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: false,
        data: {
          student,
          countries
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de información del estudiante');
    }
  }

  async openFinalBulkEmailModal(
    courseId: string,
    courseName: string,
    finalEmailSubject: string | null,
    finalEmailMessage: string | null,
    finalEmailAttachments: Array<any>
  ): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalFinalBulkEmailComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        width: '980px',
        data: {
          courseId,
          courseName,
          finalEmailSubject,
          finalEmailMessage,
          finalEmailAttachments
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar correo masivo final');
    }
  }

  async openStudentCourseAssignmentModal(courseId: string, courseName: string): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalStudentCourseAssignmentComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        width: '980px',
        data: { courseId, courseName }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de asignación de curso a estudiantes');
    }
  }

  async openAddAdminModal(): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalAddAdminComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        maxWidth: '880px',
        width: '880px',
        maxHeight: '90vh',
        height: 'fit-content',
        autoFocus: true,
        data: {}
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de agregar estudiante');
    }
  }

  async openChangeRoleModal(currentRole: Role, userId: string, name: string, lastname: string): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalChangeRoleComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: '400px',
        maxWidth: '90vw',
        maxHeight: '80vh',
        height: 'fit-content',
        autoFocus: false,
        data: { currentRole, userId, name, lastname }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de cambiar rol');
    }
  }

  /** `label` is the subtitle: an order ("#341", shown as "Pedido #341") or a product name, shown as is; falls back to the id. */
  async openEditOrderDateModal(type: string, orderId: string | number, date: string, label?: string): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalChangeOrderDateComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'modal-general',
        width: '480px',
        maxWidth: '95vw',
        maxHeight: '90vh',
        height: 'fit-content',
        autoFocus: false,
        // God orders only: the focus goes back to the button that opened it (ENF-2464 P-1).
        restoreFocus: true,
        data: { type, orderId, date, label }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de cambiar fecha de orden');
    }
  }

  /** "Vincular pago" of the god orders list. Resolves with the updated `PurchaseRow`, or `undefined` when closed without linking. */
  async openLinkPaymentModal(purchase: PurchaseRow): Promise<PurchaseRow | undefined> {
    const dialogRef = this.dialog.open<ModalLinkPaymentComponent, { purchase: PurchaseRow }, PurchaseRow | undefined>(ModalLinkPaymentComponent, {
      closeOnNavigation: true,
      disableClose: true,
      panelClass: 'modal-general',
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      height: 'fit-content',
      autoFocus: false,
      restoreFocus: true,
      data: { purchase }
    });
    return firstValueFrom(dialogRef.afterClosed());
  }

  async openVerificationCodeModal(email: string): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalVerificationCodeComponent, {
        closeOnNavigation: false,
        width: '600px',
        maxWidth: '100%',
        data: {
          email
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar curso');
    }
  }

  async openPromotionFormModal(promotionId?: string): Promise<any> {
    try {
      const dialogRef = this.dialog.open(PromotionsFormComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        data: {
          promotionId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar promoción');
    }
  }

  async openPromotionPopupModal(promotion: ActivePromotionDto, userId: string): Promise<any> {
    // Última barrera: nunca mostrar el popup de promoción por encima del modal de contraseña
    if (this.changePasswordModalOpen) return false;

    try {
      const dialogRef = this.dialog.open(ModalPromotionPopupComponent, {
        closeOnNavigation: false,
        disableClose: false,
        panelClass: 'modal-promotion-popup',
        width: 'auto',
        maxWidth: '480px',
        maxHeight: '90vh',
        autoFocus: false,
        hasBackdrop: true,
        data: {
          promotion,
          userId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con el popup de promoción');
    }
  }

  async openAmbassadorPopupModal(data: AmbassadorPopupDto): Promise<any> {
    // Última barrera: nunca mostrar el popup de embajador por encima del modal de contraseña
    if (this.changePasswordModalOpen) return false;

    try {
      const dialogRef = this.dialog.open(ModalAmbassadorPopupComponent, {
        closeOnNavigation: false,
        disableClose: false,
        panelClass: 'modal-ambassador-popup',
        width: 'auto',
        maxWidth: '480px',
        maxHeight: '90vh',
        autoFocus: false,
        hasBackdrop: true,
        data
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con el popup de embajador');
    }
  }

  async openEventFormModal(eventId?: string): Promise<any> {
    try {
      const dialogRef = this.dialog.open(EventsFormComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        data: {
          eventId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar evento');
    }
  }

  async openTrainingFormModal(trainingId?: string): Promise<any> {
    try {
      const { ModalTrainingFormComponent } =
        await import('../../../pages/god/ambassador-training/components/modal-training-form/modal-training-form.component');
      const dialogRef = this.dialog.open(ModalTrainingFormComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        data: {
          trainingId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de formación');
    }
  }

  async openModalMessageForm(messageId?: string): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalMessageFormComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        data: {
          messageId
        }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de crear/editar un mensaje');
    }
  }

  async openEditAmbassadorModal(ambassador?: Ambassador): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalEditAmbassadorComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        width: '980px',
        data: { ambassador }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de editar embajador');
    }
  }

  async openEditAmbassadorPopupModal(popup?: AmbassadorPopupDto): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalEditAmbassadorPopupComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        width: '980px',
        data: { popup }
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de popup de embajadores');
    }
  }

  async openAmbassadorVideoModal(video?: AmbassadorVideo): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalAmbassadorInfoComponent, {
        closeOnNavigation: false,
        maxWidth: '980px',
        width: '980px',
        data: video
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la ventana de video de embajador');
    }
  }

  async openAmbassadorExampleModal(example?: AmbassadorExample): Promise<any> {
    try {
      const dialogRef = this.dialog.open(ModalAmbassadorExampleComponent, {
        closeOnNavigation: false,
        maxWidth: '600px',
        width: '600px',
        data: example ?? null
      });

      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      return dialogResponse || false;
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con el formulario de ejemplo');
    }
  }

  openCalendarModal(calendarImageUrl: string, isPdf: boolean, fileName?: string) {
    try {
      return import('../../../components/modals/modal-calendar/modal-calendar.component').then((m) => {
        return this.dialog.open(m.ModalCalendarComponent, {
          closeOnNavigation: true,
          disableClose: false,
          panelClass: 'modal-preview-document',
          maxWidth: '95vw',
          width: '701px',
          maxHeight: '95vh',
          data: {
            calendarImageUrl,
            isPdf,
            fileName
          }
        });
      });
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error abriendo el calendario');
      return undefined;
    }
  }

  async openQuizFlowModal(courseClassId: string): Promise<QuizFlowDialogResult | undefined> {
    const screenWidth = window.innerWidth;
    const modalWidth = screenWidth < 768 ? '100%' : '600px';

    try {
      const dialogRef = this.dialog.open<QuizFlowComponent, QuizFlowDialogData, QuizFlowDialogResult>(QuizFlowComponent, {
        closeOnNavigation: false,
        disableClose: true,
        panelClass: 'quiz-flow-dialog',
        width: modalWidth,
        maxWidth: '100%',
        autoFocus: false,
        data: { courseClassId }
      });

      return await firstValueFrom(dialogRef.afterClosed());
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la autoevaluación');
      return undefined;
    }
  }

  async openClassRatingModal(courseClassId: string): Promise<any> {
    const screenWidth = window.innerWidth;
    const modalWidth = screenWidth < 768 ? '100%' : '600px';

    try {
      const dialogRef = this.dialog.open<ClassRatingModalComponent, ClassRatingDialogData>(ClassRatingModalComponent, {
        closeOnNavigation: false,
        disableClose: false,
        panelClass: 'rating-modal-dialog',
        width: modalWidth,
        maxWidth: '100%',
        autoFocus: false,
        data: { courseClassId }
      });

      return await firstValueFrom(dialogRef.afterClosed());
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error con la valoración de la clase');
      return undefined;
    }
  }

  async openAdminClassReviewsModal(courseClassId: string): Promise<any> {
    const screenWidth = window.innerWidth;
    const modalWidth = screenWidth < 768 ? '100%' : '600px';

    try {
      const dialogRef = this.dialog.open<AdminClassReviewsModalComponent, AdminReviewsModalData>(AdminClassReviewsModalComponent, {
        closeOnNavigation: false,
        disableClose: false,
        panelClass: 'admin-reviews-modal-dialog',
        width: modalWidth,
        height: screenWidth < 768 ? undefined : '661px',
        maxWidth: '100%',
        maxHeight: screenWidth < 768 ? '90vh' : 'none',
        autoFocus: false,
        data: { courseClassId }
      });

      return await firstValueFrom(dialogRef.afterClosed());
    } catch (_error) {
      this.toast.presentErrorToast('Hubo un error cargando las valoraciones');
      return undefined;
    }
  }
}
